import * as ga4 from './ga4';
import Collapse from 'bootstrap/js/dist/collapse';

window.addEventListener("load", (event) => {
	//
	// js pour l'ouverture du panel de gestion des cookies
	//
	const open = document.getElementsByClassName("open");
	for (let i = 0; i < open.length; i++) {
		open[i].addEventListener("click", function () {
			event.preventDefault();
			tarteaucitron.userInterface.openPanel();
		});
	}
	
	//
	// js pour la réécriture des emails
	//
	function deObfuscateEmail(mail) {
		mail.href = mail.href.replace(new RegExp("%7BAT%7D", 'g'), '@').replace(new RegExp("%7BDOT%7D", 'g'), '.');
		mail.innerText = mail.innerText.replace(new RegExp("{AT}", 'g'), '@').replace(new RegExp("{DOT}", 'g'), '.');

		mail.classList.remove('opacity-0');
	}

	document.querySelectorAll('.obfuscated').forEach((mail) => {
		deObfuscateEmail(mail);
	});

	//
	// js pour afficher la gestion du consentement aux cookies
	//
	document.querySelectorAll('.complianz > *, a.complianz, #navigation-footer #menu-item-130 > a').forEach((el) => {
		el.addEventListener('click', (event) => {
			event.preventDefault();
			cmplz_set_banner_status('');
		});
	});

	//
	// js pour transformer les liens
	//
	var links = document.querySelectorAll('[role="link"]');

	function dataToHref(link) {
		if (link.hasAttribute('data-href')) {
			link.setAttribute('href', link.getAttribute('data-href'));
			link.removeAttribute('data-href');
		}
	}

	links.forEach(function (link) {
		link.addEventListener('mouseover', function () {
			dataToHref(this);
		});

		link.addEventListener('focusin', function () {
			dataToHref(this);
		});

		link.addEventListener('click', function () {
			dataToHref(this);
		});
	});

	//
	// GA4 et Marketing
	//
	ga4.addGtagOnConsent(function () {
		ga4.clickGtagEvent(".btn-cta-header-contact", "cta_header_contact_click", "Header - Contact");
		ga4.clickGtagEvent(".btn-cta-header-phone", "cta_header_phone_click", "Header - Téléphone");
		ga4.clickGtagEvent(".btn-cta-header-home", "cta_header_home_click", "Header - Accueil");
		ga4.clickGtagEvent(".btn-cta-header-pages", "cta_header_pages_click", "Header - Pages");

		ga4.clickGtagEvent(".btn-cta-body-phone", "cta_body_phone_click", "Body - Téléphone");
		ga4.clickGtagEvent(".btn-cta-body-email", "cta_body_email_click", "Body - Email");
		ga4.clickGtagEvent(".btn-cta-body-add-to-cart", "cta_body_add_to_cart_click", "Body - Ajout au panier");
		ga4.clickGtagEvent(".btn-cta-body", "cta_body_click", "Body");

		ga4.clickGtagEvent(".btn-cta-footer-phone", "cta_footer_phone_click", "Footer - Téléphone");
		ga4.clickGtagEvent(".btn-cta-footer-contact", "cta_footer_contact_click", "Footer - Contact");
		ga4.clickGtagEvent(".btn-cta-footer", "cta_footer_click", "Footer");

		ga4.submitGtagEvent("contact-form", "form_contact_submit", "Contact");
		ga4.inputStartGtagEvent("#contact-form", false, "form_contact_input_start", "Contact");

		ga4.submitGtagEvent("newsletter-form", "form_newsletter_submit", "Newsletter");

		ga4.elementGtagEvent('#form-contact-submited', "page_contact_submited", 'Contact - Envoyé', {category: 'page_view'})
		ga4.elementGtagEvent('#form-contact-error-send', "page_contact_error_send", "Contact - Problème d'envoi", {category: 'page_view'})
		ga4.elementGtagEvent('#form-contact-error-captcha-score', "page_contact_error_captcha_score", 'Contact - Problème de captcha (score)', {category: 'page_view'})
		ga4.elementGtagEvent('#form-contact-error-captcha', "page_contact_error_captcha", 'Contact - Problème de captcha', {category: 'page_view'})
		ga4.elementGtagEvent('#form-contact-error-email', "page_contact_error_email", 'Contact - Email manquant', {category: 'page_view'})
	})

});